<div class="d-flex flex-row align-items-center">
  @if (letter.length === 1) {
    <div class="mr-2">{{ letter }}</div>
  }
  <div class="badge" [class]="decoration">{{ text }}</div>
</div>
